import { render, staticRenderFns } from "./CourseAllPage.vue?vue&type=template&id=be4a1992&scoped=true"
import script from "./CourseAllPage.vue?vue&type=script&lang=js"
export * from "./CourseAllPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be4a1992",
  null
  
)

export default component.exports